import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0475df13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-box" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "detail-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CosFixFooterPage = _resolveComponent("CosFixFooterPage")!
  const _directive_trim = _resolveDirective("trim")!

  return (_openBlock(), _createBlock(_component_CosFixFooterPage, null, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        "html-type": "submit",
        onClick: _ctx.handleSubmit,
        disabled: !_ctx.showEditDetail
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('btn.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('system.cvk1qq')), 1),
        _createVNode(_component_a_spin, { spinning: _ctx.spinning }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_form, {
                model: _ctx.formState,
                ref: "formDetail",
                name: "basic",
                "wrapper-col": { span: 22 },
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { gutter: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: _ctx.t('system.ibq5bm'),
                            name: "topName",
                            class: "tree-detail-box"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.formState.topName,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.topName) = $event)),
                                disabled: true,
                                style: {"width":"100%"}
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { gutter: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: _ctx.t('system.7mh4ly'),
                            name: "cnName",
                            rules: [{ required: true, message: _ctx.t('common.pleaseInput') }],
                            class: "tree-detail-box"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_a_input, {
                                value: _ctx.formState.cnName,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.cnName) = $event)),
                                placeholder: _ctx.t('common.pleaseInput'),
                                disabled: !_ctx.showEditDetail
                              }, null, 8, ["value", "placeholder", "disabled"]), [
                                [_directive_trim]
                              ])
                            ]),
                            _: 1
                          }, 8, ["label", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: _ctx.t('system.3rw46j'),
                            name: "status",
                            rules: [{ required: true, message: _ctx.t('common.pleaseInput') }],
                            class: "tree-detail-box"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.formState.status,
                                "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.status) = $event)),
                                "checked-children": _ctx.t('system.j8i04n'),
                                "un-checked-children": _ctx.t('system.426zce'),
                                checkedValue: 0,
                                unCheckedValue: 1,
                                disabled: !_ctx.showEditDetail
                              }, null, 8, ["checked", "checked-children", "un-checked-children", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["label", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { gutter: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: _ctx.t('system.qkqppn'),
                            name: "enName",
                            rules: [{ required: true, message: _ctx.t('common.pleaseInput') }],
                            class: "tree-detail-box"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_a_input, {
                                value: _ctx.formState.enName,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.enName) = $event)),
                                placeholder: _ctx.t('common.pleaseInput'),
                                disabled: !_ctx.showEditDetail
                              }, null, 8, ["value", "placeholder", "disabled"]), [
                                [_directive_trim]
                              ])
                            ]),
                            _: 1
                          }, 8, ["label", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: _ctx.t('system.j36v6p'),
                            name: "operator",
                            class: "tree-detail-box"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_a_input, {
                                value: _ctx.formState.operator,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.operator) = $event)),
                                disabled: true
                              }, null, 8, ["value"]), [
                                [_directive_trim]
                              ])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { gutter: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: _ctx.t('system.p6nvup'),
                            name: "sort",
                            rules: [{ required: true, message: _ctx.t('common.pleaseInput') }],
                            class: "tree-detail-box"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_number, {
                                min: 0,
                                value: _ctx.formState.sort,
                                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.sort) = $event)),
                                placeholder: _ctx.t('common.pleaseInput'),
                                disabled: !_ctx.showEditDetail
                              }, null, 8, ["value", "placeholder", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["label", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: _ctx.t('system.fvakdn'),
                            name: "operationTime",
                            class: "tree-detail-box"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_a_input, {
                                value: _ctx.formState.operationTime,
                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.operationTime) = $event)),
                                disabled: true
                              }, null, 8, ["value"]), [
                                [_directive_trim]
                              ])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { gutter: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: _ctx.t('system.wl73jo'),
                            name: "comment",
                            class: "tree-detail-box"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_a_input, {
                                value: _ctx.formState.comment,
                                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.comment) = $event)),
                                placeholder: _ctx.t('common.pleaseInput'),
                                disabled: !_ctx.showEditDetail
                              }, null, 8, ["value", "placeholder", "disabled"]), [
                                [_directive_trim]
                              ])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _: 1
        }, 8, ["spinning"])
      ])
    ]),
    _: 1
  }))
}